<form [formGroup]="placeForm" (ngSubmit)="onSubmit()">

    <mat-form-field class="w-full">
        <mat-label>Place</mat-label>
        <mat-select [disabled]="isSaving || isLoading" [formControl]="placeTypeControl"
        (optionSelected)="onPlaceTypeSelected($event)">
        <mat-option value="Vehicle">Vehicle</mat-option>
        <mat-option value="Clinic">Clinic</mat-option>
        <mat-option value="Custom">Other</mat-option>
    </mat-select>
</mat-form-field>

<!-- SELECT VEHICLE -->
<app-search-vehicle class="w-full" *ngIf="placeTypeControl.value == 'Vehicle'" [vehicleControl]="vehicleControl">
</app-search-vehicle>

<!-- SELECT CLINIC -->
<app-search-clinic class="w-full" *ngIf="placeTypeControl.value == 'Clinic'" [clinicControl]="clinicControl">
</app-search-clinic>
<mat-form-field class="w-full" *ngIf="placeTypeControl.value == 'Custom'">
    <mat-label>Specify</mat-label>
    <input [formControl]="customStringControl" placeholder="e.g. Freezer 1" matInput [disabled]="isSaving" />
</mat-form-field>
<div>
    <button mat-raised-button color="primary" [disabled]="!placeForm.valid">Select</button>
</div>
</form>